// Wortlaute der Erklärung „Projektkosten“. Regeln für jeden Text: siehe ../help.js.
export default {
  title: "Projektkosten",
  // Kurznamen der Seiten, für die Kopfzeile, die Zeitleiste und "Weiter zu …".
  section: {
    ProjectCosts: "Alle Projekte",
    ProjectCostsForOne: "Einzelnes Projekt",
    HourlyWageReportCosts: "[[hwr]]",
    ConstructionReportCosts: "[[cr]]",
    // Die verwandten Ansichten, in der Reihenfolge, in der sie gespielt werden.
    UserPositionDetail: "Personalrolle",
    MaterialDetail: "Material",
    SettingsOverview: "Einstellungen",
    EmployeeDetail: "Mitarbeitender",
    ProjectDetail: "Projekt",
  },
  // Überschrift des letzten Kapitels, vor dem Namen der jeweiligen Ansicht.
  related: "Zusammenhänge",
  step: {
    // ── Alle Projekte ──────────────────────────────────────────────────────
    intro: {
      text: "Die mitlaufende Nachkalkulation zeigt, was Ihre Projekte bisher gekostet haben. Sie rechnet laufend aus den Berichten und stellt die Kosten dem Budget gegenüber.",
    },
    projects: {
      text: "Hier wählen Sie, über welche Projekte die Übersicht rechnet. Beim ersten Öffnen sind alle ausgewählt.",
    },
    range: { text: "Von und Bis begrenzen den Zeitraum. Gezählt wird jeder Bericht, der in diesen Tagen liegt." },
    presets: {
      text: "Die Kurzwahl setzt den Zeitraum auf 30 Tage, 90 Tage, das Jahr oder den Monat. Danach rechnet jede Zahl auf der Seite neu.",
    },
    valuation: {
      text: "Kosten zeigt, was die Arbeit das Unternehmen kostet. Erlös zeigt, was sie nach den Verkaufspreisen des Projekts wert ist.",
    },
    modes: {
      text: "Vier Ansichten auf dieselben Zahlen. Heatmap nach Tagen, Verlauf als Summe, KW nach Kalenderwochen, Analyse nach Kostenarten.",
    },
    health: {
      text: "Die Kopfzeile sagt, wie das Unternehmen im Ganzen steht. Sie vergleicht den Budgetverbrauch mit dem Fertigstellungsgrad und zählt die Projekte je Status.",
    },
    combined: {
      text: "Aufgeklappt steht hier die Summe aller ausgewählten Projekte in der gerade gewählten Ansicht.",
    },
    heatmap: {
      text: "Eine Zeile je Projekt, eine Spalte je Tag. Je dunkler ein Tag, desto mehr Kosten sind an ihm gebucht.",
    },
    "heatmap-row": {
      text: "Vor dem Projektnamen zeigt ein Zeichen, ob der Budgetverbrauch zum Fortschritt passt. Läuft er dem Fertigstellungsgrad voraus, wird es gelb oder rot.",
    },
    "heatmap-total": {
      text: "Rechts steht die Summe des Zeitraums. Der Pfeil daneben klappt den Verlauf des Projekts auf.",
    },
    day: {
      text: "Ein Klick auf einen Tag zeigt, aus welchen Kostenarten er besteht und welche Berichte dahinterstehen.",
    },
    "show-cr": {
      text: "Die zwei Schalter sagen, welche Berichte zählen. [[cr.pl]] rechnen eigene Kosten, denn dieselbe Arbeit kann auch in [[hwr:einem/einer/einem]] [[hwr]] stehen.",
    },
    chart: {
      text: "Der Verlauf summiert die Kosten über den Zeitraum auf. So sehen Sie, wie schnell das Budget aufgebraucht wird.",
    },
    week: {
      text: "Die KW-Ansicht summiert jede Kalenderwoche nach Kostenart. Ein Klick auf eine Woche zeigt ihre Berichte.",
    },
    analysis: {
      text: "Die Analyse zeigt den Anteil der Kostenarten, die Rangfolge der Projekte und die teuersten Berichte.",
    },
    notice: {
      text: "Gerechnet wird mit den Sätzen und Preisen, die heute hinterlegt sind. Frühere Abrechnungen können davon abweichen.",
    },

    // ── Ein Projekt ────────────────────────────────────────────────────────
    single: {
      text: "Dieselbe Seite für ein einzelnes Projekt. Der Zeitraum steht beim Öffnen auf der geplanten Montagezeit.",
    },
    budget: {
      text: "Das Budget ist eine Obergrenze für die Kosten des Projekts. Der Status misst den verbrauchten Anteil am Fertigstellungsgrad, der aus dem Leistungskatalog kommt oder hier von Hand eingetragen wird. Stille Monate schaden also nicht.",
    },
    plan: {
      text: "Die Nachkalkulation vergleicht den Auftragswert mit den Kosten bis heute. Daraus kommt der erwartete Gewinn.",
    },
    manual: {
      text: "Kosten und Einnahmen ohne Bericht tragen Sie hier ein. Sie zählen in die Kosten bis heute und in die Marge.",
    },
    rentals: {
      text: "Mieten sind in den Maschinenkosten enthalten, Tage ohne Einsatz nach den Konditionen des Lieferanten. Berichte zeigen das gemietete Gerät an diesen Tagen als „in Miete enthalten“.",
    },
    services: {
      text: "Fertigstellung und Leistungswert kommen aus dem Leistungskatalog. Die Ansicht „Leistungen“ zeigt Kosten und Deckungsbeitrag je Position.",
    },
    "week-reports": {
      text: "Hinter jeder Woche stehen ihre Berichte. Ein Klick öffnet die Kostenaufstellung eines einzelnen Berichts.",
    },

    // ── Stundenlohnbericht ─────────────────────────────────────────────────
    "hwr-head": {
      text: "Die Kostenaufstellung [[hwr:eines/einer/eines]] einzelnen [[hwr.gen]]. Oben stehen [[hwr:seine/ihre/seine]] Nummer, [[hwr:sein/ihr/sein]] Tag und [[hwr:sein/ihr/sein]] Projekt.",
    },
    "hwr-summary": { text: "Die Leiste summiert den Bericht nach Lohn, Maschinen, Material und Zusatzleistungen." },
    "hwr-labor": {
      text: "Jede Stunde rechnet mit dem Stundensatz ihrer Personalrolle. In der Kostenspalte steckt zusätzlich der Arbeitgeberanteil.",
    },
    "hwr-machines": {
      text: "Maschinen rechnen Menge mal Stunden mal Einkaufspreis. Bei einem Tagessatz zählt jeder angefangene Einsatztag.",
    },
    "hwr-materials": { text: "Material und Zusatzleistungen rechnen ihre Menge mal ihren Einkaufspreis." },
    "hwr-print": { text: "Der Druck liefert dieselbe Aufstellung als PDF, mit denselben Zahlen wie hier." },
    "hwr-open": {
      text: "Hier öffnet sich [[hwr:der/die/das]] [[hwr]] selbst, im selben Panel wie im Projekt. Nach dem Speichern rechnet die Seite neu.",
    },

    // ── Bautagesbericht ────────────────────────────────────────────────────
    "cr-summary": {
      text: "[[cr:Beim/Bei der/Beim]] [[cr]] summiert die Leiste Lohn, Maschinen und Material. Zusatzleistungen kennt [[cr:er/sie/es]] nicht.",
    },
    "cr-shift": { text: "Jede Schicht bringt ihre Arbeitszeit, ihre Pause und ihre Zwischensumme mit." },
    "cr-labor": {
      text: "Die Lohnzeile rechnet die Arbeitszeit der Schicht mal den Stundensatz mal die Zahl der Leute. Der Arbeitgeberanteil kommt hinzu.",
    },
    "cr-machines": {
      text: "Mit Stundensatz zählt ein Gerät die Arbeitszeit seiner Schichten. Mit Tagessatz zählt jeder Einsatztag, über Mitternacht ein zweiter.",
    },
    again: { text: "Diese Schaltfläche steht auf jeder Seite mit Erklärung. Ein Klick startet sie erneut." },

    // ── Zusammenhänge ────────────────────────────────────────────────────────
    "position-rate": {
      text: "Mit dem Stundensatz der Personalrolle rechnen die Kosten jede Stunde. Der Satz im Projekt, vorbelegt vom Kunden, gilt für den Erlös und für die Kosten nur, wenn hier keiner steht.",
    },
    "material-price": {
      text: "Mit dem Einkaufspreis, der beim Buchen gewählt und festgeschrieben wurde, rechnen die Kosten jede verbaute Menge. Ein später geänderter Preis gilt für bestehende Buchungen erst nach „Umstellen“ unter dem Preis im Projekt. Den Verkaufspreis legt das Projekt fest, vorbelegt aus den Preisen des Kunden.",
    },
    "settings-contribution": {
      text: "Der Arbeitgeberanteil aus den Einstellungen wird auf jede Lohnstunde aufgeschlagen. Die Lohnkosten der Projekte sind deshalb Vollkosten.",
    },
    "employee-tabs": { text: "Unter Unternehmens-relevant steht alles, was den Lohn dieser Person betrifft." },
    "employee-contribution": {
      text: "Ein eigener Anteil für diese Person ersetzt den Wert aus den Einstellungen. Nur ihre Stunden rechnen damit.",
    },
    "hwr-register-costs": {
      text: "Die Kostenaufstellung öffnen Sie auch in der Liste der [[hwr.pl]]. Jede Zeile hat dafür eine eigene Schaltfläche.",
    },
    "cr-register-costs": {
      text: "Dieselbe Schaltfläche steht in jeder Zeile der [[cr.pl]]. Sie öffnet die Kostenaufstellung des Berichts.",
    },
  },
}
